//import { useRecoilValue } from 'recoil';

///import { initAndLinkProgressState } from '../../atoms';
import HeartIconActive from '../../assets/imgs/heart-icon-active.svg';

export type CircleImageSize = 'tiny' | 'small' | 'medium' | 'large';

// const sizeDeltas: {
// 	[_ in CircleImageSize]: number;
// } = {
// 	tiny: 0,
// 	small: 0.2,
// 	medium: 0.15,
// 	large: 0.1
// };

export type CircleImageProps = {
	label: string;
	url: string;
	alt: string;
	className: string;
	isFavorite?: boolean | undefined;
	id?: string;
	size?: CircleImageSize;
	onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const CircleImage: React.FC<CircleImageProps> = ({
	label,
	url,
	alt,
	className,
	isFavorite,
	id,
	size = 'medium',
	onClick
}) => {
	// const initAndLinkProgress = useRecoilValue(initAndLinkProgressState);

	// const [{ zoom }, set] = useSpring(() => ({
	// 	zoom: 1,
	// 	config: { tension: 250, friction: 10 }
	// }));

	// const initFinishedCallback = (cb: () => void) => () => {
	// 	if (initAndLinkProgress === 100) {
	// 		cb();
	// 	}
	// };

	// const delta = sizeDeltas[size];
	// const grow = initFinishedCallback(() => set.start({ zoom: 1 + delta }));
	// const normal = initFinishedCallback(() => set.start({ zoom: 1 }));
	// const shrink = initFinishedCallback(() => set.start({ zoom: 1 - delta }));

	return (
		<div className={`circle-image-container ${className}`}>
			<div
				style={{
					// transform: zoom?.to((z: number) => `scale(${z})`)
					transform: `scale(1)`
				}}
				className={`circle-image-wrapper ${size}${
					size === 'tiny' ? '' : ' mb-3'
				}`}
				onClick={onClick}
				// onMouseEnter={grow}
				// onMouseLeave={normal}
				// onTouchStart={shrink}
				// onTouchCancel={normal}
				// onTouchEnd={normal}
				// onTouchMove={normal}
				// onFocus={shrink}
				// onBlur={normal}
				// onMouseDown={shrink}
			>
				<img
					src={url}
					alt={alt}
					className="circle-image"
					style={{ objectFit: 'cover' }}
				/>
			</div>
			{isFavorite && (
				<img
					id={id}
					className="products-list-favorite"
					src={HeartIconActive}
					alt="favorite"
				/>
			)}

			{size !== 'tiny' && <p className={size}>{label}</p>}
		</div>
	);
};
